import { apiGet } from 'api';
import { GetConsultationDocumentRequest, GetConsultationDocumentResponse } from '../../types';

export const getConsultationDocument = (
  request: GetConsultationDocumentRequest
): Promise<GetConsultationDocumentResponse> =>
  apiGet<
    GetConsultationDocumentResponse,
    Pick<GetConsultationDocumentRequest, 'documentSource'>
  >(`consultations/${request.consultationId}/document/${request.documentId}`, {
    documentSource: request.documentSource,
  });
